const isAdminPortalVariant = (portalVariant) =>
  portalVariant === "admin-portal";

export const isTagOwnedByMe = (userTag, myCompanyId) =>
  userTag?.owner_type === "Company" &&
  String(userTag?.owner_id) === String(myCompanyId);

/** Whether the current actor can edit/delete the given row's tag. */
export const canManageTagRow = (row, { portalVariant, myCompanyId }) => {
  if (isAdminPortalVariant(portalVariant)) return true;
  const userTag = row?.userTag;
  if (!userTag) return true;
  return isTagOwnedByMe(userTag, myCompanyId);
};

/**
 * Split a selection into eligible / skipped buckets for a bulk tag action.
 * `mode` is "assign" or "remove".
 *  - assign: untagged + own-tag (admin: any tag) are eligible.
 *  - remove: only own-tag (admin: any tag) are eligible; untagged are skipped.
 */
export const getTagEligibility = (
  applicants = [],
  { portalVariant, myCompanyId, mode },
) => {
  const isAdmin = isAdminPortalVariant(portalVariant);
  const eligibleUserIds = [];
  let updatedCount = 0;
  let untaggedCount = 0;
  let otherOwnerCount = 0;

  applicants.forEach((applicant) => {
    const userTag = applicant?.userTag;
    const ownedByMe = isAdmin || isTagOwnedByMe(userTag, myCompanyId);

    if (!userTag) {
      // Untagged: eligible for bulk assign, skipped for bulk remove.
      untaggedCount += 1;
      if (mode === "assign" && applicant?.userId) {
        eligibleUserIds.push(applicant.userId);
      }
    } else if (ownedByMe) {
      // Tagged & owned by me (or admin): editable for both assign (replace)
      // and remove.
      updatedCount += 1;
      if (applicant?.userId) eligibleUserIds.push(applicant.userId);
    } else {
      // Tagged & owned by another company: always skipped.
      otherOwnerCount += 1;
    }
  });

  return {
    total: applicants.length,
    eligibleUserIds,
    updatedCount,
    untaggedCount,
    otherOwnerCount,
  };
};
